import React from "react";
import Label from "components/general/Label";
import { findArray, RscFromStore } from 'helpers/utils'
import { getRscObject } from "helpers/rsc";

export const TableExpanded = React.memo((props) => {
  const { row } = props;
  const eventUnitType = props?.eventUnitType;

  const data = ((row?.extendedResults?.length > 0))
    ? row?.extendedResults
    : undefined

  let dificulty = findArray(data, { er_type: ['ER'], er_code: ['DIFFICULTY'] })?.er_value
  let elements = findArray(data, { er_type: ['TOTAL'], er_code: ['ELEMENT'] })?.er_value
  let impression = findArray(data, { er_type: ['TOTAL'], er_code: ['IMPRESSION'] })?.er_value
  let penalty = row?.pty
  console.log(data)
  let dataTeam = row?.teamAthletes?.some(val => val.hasOwnProperty('athlete'))
    ? row.teamAthletes
    : undefined

  dataTeam.sort((a, b) => a.order - b.order);
  const { sex: gender } = getRscObject(RscFromStore());
  let showGender = true;

  return (
    <>
      {eventUnitType === 'TEAM' && <table className="table table-striped table-bordered w-60 m-auto">
        <tbody>
          {dataTeam && dataTeam.map((val, key) => {
            let res = findArray(data, { er_pos: [val.ei_pos] })
            return (
              <tr key={'expanded_' + val.athlete.code + '_' + key}>
                <td className="text-start">{val.athlete.name}</td>
                {showGender && <td className="text-start">{val.athlete.personGender.code}</td>}
              </tr>
            )
          })}
        </tbody>
      </table>}

      <table className="table table-detail w-60 m-auto">

        <thead>
          <tr>
            <th className='w-60'><Label data={'HeaderDifficultyDegree'} /></th>
            <th className="w-40 text-end">{dificulty}</th>
          </tr>
        </thead>

        <tbody>

          <tr>
            <td className='w-60'><Label data={'LabelElements'} /></td>
            <td className="w-40 text-end">{elements}</td>
          </tr>
          <tr>
            <td className='w-60'><Label data={'HeaderArtisticImpressionDesc'} /></td>
            <td className="w-40 text-end">{impression}</td>
          </tr>

          <tr>
            <td className='w-60'><Label data={'HeaderPenalties'} /></td>
            <td className="w-40 text-end">{penalty}</td>
          </tr>

        </tbody>
      </table>
    </>
  );
});

export default TableExpanded